import { PICKUP_OFFERINGS_VIEWED } from '../../../../../analytics/constants';
import getPickupOfferingStatus from '../../../../../analytics/get-pickup-offering-status';
import trackEvent from '../../../../../analytics/track-event';
import { OPEN_SHOP_MODAL, CLOSE_SHOP_MODAL } from '../types';

/**
 * @public
 * @memberof NikeShop
 * @name NikeShop.toggleDialog
 * @returns {undefined} toggles ShopModal open and close
 */
export function toggleDialog({
  itemId,
  skuId,
  productId,
  showPickupIneligibleMessage,
  fulfillmentType = 'SHIP',
}) {
  const isOpen = this.internalStore.getState()?.ui?.isModalOpen;

  if (fulfillmentType === 'PICKUP') {
    trackEvent(
      PICKUP_OFFERINGS_VIEWED,
      { fulfillment: { pickupOfferingStatus: getPickupOfferingStatus(itemId) } },
      {
        usePageAction: true,
      },
    );
  }

  return this.internalStore.dispatch({
    type: isOpen ? CLOSE_SHOP_MODAL : OPEN_SHOP_MODAL,
    payload: {
      itemId,
      skuId,
      productId,
      showPickupIneligibleMessage,
      fulfillmentType,
    },
  });
}
